import type { BooksHealthRepository, GetBooksHealthOverviewParams } from "../repositories/BooksHealthRepository";
import type { BooksHealthOverviewEntity } from "../entities/BooksHealthEntity";

export class GetBooksHealthOverviewUseCase {
  constructor(private readonly repository: BooksHealthRepository) {}

  async execute(params?: GetBooksHealthOverviewParams): Promise<BooksHealthOverviewEntity> {
    return this.repository.getBooksHealthOverview(params);
  }
}
